// extracted by mini-css-extract-plugin
export default {"disabled":"FormType_disabled__YEgj3","transferSchema":"FormType_transferSchema__V95Lu"};